import React from 'react';
import { Box, useTheme } from '@mui/material';
import ReportsMobileCard from '../common/ReportsMobileCard';
import CopyButton from '../common/CopyButton';
import { formatTimeToIST, formatDateToIST } from '../../../utils/dateUtils';
import { formatTradeValue } from './tradeHistoryFormatters';

const tradeValue = (trade) => {
  const value = formatTradeValue(trade);
  return value ? `₹${value}` : '-';
};

// Trade rows as flat cards on phones. Date and time both use IST, like the
// desktop columns, so they always describe the same instant.
const TradeHistoryMobileList = ({ trades }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 1,
        willChange: 'scroll-position',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {trades.map((trade) => {
        const isBuy = trade.buy_sell === 0;
        const when = [formatDateToIST(trade.created_at), formatTimeToIST(trade.created_at)]
          .filter(Boolean)
          .join(' · ');

        return (
          <ReportsMobileCard
            key={trade.trade_id || trade.id}
            lines={[
              {
                left: (
                  <>
                    {trade.trading_symbol}
                    <Box component="span" sx={{ color: 'text.secondary', fontWeight: 400 }}>{' · '}</Box>
                    <Box
                      component="span"
                      sx={{ fontWeight: 400, color: isBuy ? theme.palette.success.main : theme.palette.error.main }}
                    >
                      {isBuy ? 'Buy' : 'Sell'}
                    </Box>
                  </>
                ),
                right: { label: 'Qty', value: trade.fill_quantity },
              },
              {
                left: when || '-',
                right: { label: 'Price', value: `₹${trade.fill_price}` },
              },
            ]}
            footer={`Order ID: ${trade.order_id || '-'}`}
            footerAction={trade.order_id
              ? <CopyButton value={trade.order_id} label="order ID" size="medium" />
              : null}
            footerActionInline
            footerRight={{ label: 'Value', value: tradeValue(trade), strong: true }}
          />
        );
      })}
    </Box>
  );
};

export default TradeHistoryMobileList;
